module.exports = __webpack_public_path__ + "img/AFTER LONG.png";